import classNames from 'classnames';
import { Link as _Link } from 'react-router-dom';
import styles from './styles.module.css';
import { FC } from 'react';

type Variant = 'small';
type Props = {
  variants?: Variant[];
} & Omit<React.ComponentProps<typeof _Link>, 'className' | 'style'>;

const TextLink: FC<Props> = ({ variants = [], children, ...props }: Props) => {
  const LinkClassNames = classNames(
    styles.link,
    variants.map((v) => styles[v])
  );
  return (
    <_Link {...props} className={LinkClassNames}>
      {children}
    </_Link>
  );
};
TextLink.displayName = 'Link';

export default TextLink;
